import React, { useState, useEffect } from "react"
import ProgramPerformanceTable from "../../../components/ui/program-performance-table"
import { computeProgramPerformance } from "../../../utils/programPerformanceHelpers"

const ProgramPerformanceSection = ({ orgId, onNavigateTab }) => {
  const [programs, setPrograms] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    computeProgramPerformance(orgId).then((rows) => {
      setPrograms(rows)
      setLoading(false)
    })
  }, [orgId])

  if (loading) {
    return <div className="h-80 bg-muted rounded-lg animate-pulse mb-6" />
  }

  return (
    <div className="bg-card border border-border rounded-lg p-5 mb-6">
      <ProgramPerformanceTable
        title="Program Performance"
        programs={programs}
        onViewAnalytics={(row) => onNavigateTab?.(row?.analyticsTab)}
      />
    </div>
  )
}

export default ProgramPerformanceSection